import _extends from "@babel/runtime/helpers/extends";
import { EnlargedSearchResultContent } from '@atlassian/search-dialog';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../messages';
import { useProductContext } from '../../../product-router';
import { useQuery } from '../../../query-context';
import { useRecentSearches } from '../../../recent-searches';
import { QuickFindIcon } from '../../../recent-searches/icons/quick-find-icon';
import { useSearchResultAnalyticsCallbacks } from '../../../search-result';
import { PersistRecentSearch } from '../../../recent-searches/persist-recent-search';
export var RECENT_SEARCHES_SECTION_ID = 'recent-searches';
var MAX_RECENT_SEARCHES_SHOWN_IN_PRE_QUERY = 3;
var MAX_RECENT_SEARCHES_SHOWN_IN_POST_QUERY = 1;
export var useRecentSearchesSection = function useRecentSearchesSection() {
  var _useQuery = useQuery(),
    query = _useQuery.query;
  var _useProductContext = useProductContext(),
    getActiveProduct = _useProductContext.getActiveProduct;
  var recentSearches = useRecentSearches({
    Icon: /*#__PURE__*/React.createElement(QuickFindIcon, null)
  }).map(function (result) {
    var _getActiveProduct, _getActiveProduct$gen;
    return {
      id: result.id,
      title: result.title,
      icon: result.icon,
      url: ((_getActiveProduct = getActiveProduct()) === null || _getActiveProduct === void 0 || (_getActiveProduct$gen = _getActiveProduct.generateAdvancedSearchUrl) === null || _getActiveProduct$gen === void 0 ? void 0 : _getActiveProduct$gen.call(_getActiveProduct, result.title)) || '',
      meta: '',
      additionalMeta: query !== '' ? /*#__PURE__*/React.createElement(FormattedMessage, messages.quick_find_recent_search_text_dialog) : undefined
    };
  });
  var recentSearchesSection = useMemo(function () {
    return {
      id: RECENT_SEARCHES_SECTION_ID,
      title: '',
      searchResults: recentSearches,
      resultRenderer: function resultRenderer(_ref) {
        var searchResult = _ref.searchResult,
          isKeyboardHighlighted = _ref.isKeyboardHighlighted,
          isCollapsed = _ref.isCollapsed;
        return /*#__PURE__*/React.createElement(PersistRecentSearch, {
          overrideQuery: searchResult.title
        }, /*#__PURE__*/React.createElement(EnlargedSearchResultContent, _extends({}, searchResult, {
          icon: searchResult.icon,
          isKeyboardHighlighted: isKeyboardHighlighted,
          isCollapsed: isCollapsed,
          returnIcon: "onHighlight"
        })));
      },
      resultLimit: query ? MAX_RECENT_SEARCHES_SHOWN_IN_POST_QUERY : MAX_RECENT_SEARCHES_SHOWN_IN_PRE_QUERY,
      useAnalyticsOverride: function useAnalyticsOverride(_ref2) {
        var screen = _ref2.screen;
        return useSearchResultAnalyticsCallbacks({
          screen: screen,
          actionSubject: 'recentSearch'
        });
      }
    };
  }, [query, recentSearches]);
  return recentSearchesSection;
};